import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/AuthContext'

interface Props {
  onDelete: () => Promise<void>
}

export function ModeratorDeleteButton({ onDelete }: Props) {
  const { t } = useTranslation()
  const { user } = useAuth()
  const [confirming, setConfirming] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (!user?.moderator && !user?.admin) return null

  async function handleDelete() {
    if (busy) return
    setBusy(true)
    setError(null)
    try {
      await onDelete()
    } catch (caught) {
      setError(
        caught instanceof Error && caught.message
          ? caught.message
          : t('moderation.deleteFailed'),
      )
      setBusy(false)
      setConfirming(false)
    }
  }

  return (
    <div className="moderator-actions">
      {!confirming ? (
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => setConfirming(true)}
        >
          {t('moderation.delete')}
        </button>
      ) : (
        <div className="moderator-confirm">
          <p className="field-help">{t('moderation.deleteConfirm')}</p>
          {error && (
            <p className="field-error" role="alert">
              {error}
            </p>
          )}
          <div className="form-actions">
            <button
              type="button"
              className="btn btn-ghost"
              onClick={() => {
                setConfirming(false)
                setError(null)
              }}
              disabled={busy}
            >
              {t('actions.cancel')}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => void handleDelete()}
              disabled={busy}
            >
              {busy ? t('moderation.deleting') : t('moderation.confirmDelete')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
